import { trackForInstall } from '@webapp-next/lib/tracking';

/**
 * Function to be used in Once context where the installation context is not
 * set automatically and will be using legacy installation model
 *
 * @param {Object} event
 * @param {Object} data
 * @param {Object} model
 */
export function trackForInstallLegacyModel(event, data, model) {
  trackForInstall(event, data, {
    ID: model.get('id'),
    installationId: model.get('id'),
    hostname: model.get('Hostname'),
    edition: {
      ID: model.get('Plan'),
      edition: DP.getSubscriptionNameServerMapping(model.get('Plan')),
    },
    country: model.get('Country'),
  });
}
